module.exports = __webpack_public_path__ + "static/media/christian.53979dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christian.jpg
// module id = 92
// module chunks = 0